<template>
<div class="page_content" aria-label="Program Guide Upload Page Content">
	  <div>
	    <div class="row page-heading">
	      <div class="col-7 input module_heading" role="heading" aria-level="1">
	        <span class="module_icon icon-list"></span>
	        <span class="module_type_name">Programguide Upload</span>
	     </div>
	     <div class="col-5 btn_container">
	     	<b-btn @click="uploadProgramGuideClicked" aria-label="upload">upload</b-btn>
	     </div>

	   </div>

	   <div class="create-section">
	  		<div class="content-section">
				<div class="row content-row">
					<div class="col-2"></div>
					<div class="col-8">
					   <textarea class="form-control" rows="20" style="height: 350px;" v-model="programGuideData" aria-label="Please enter Program Guide JSON" placeholder="Please enter Program Guide JSON"></textarea>
					</div>
				</div>
			</div>
	    </div>
	  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'program-guide-upload',
  props: [],
  data: () => {
    return {
      programGuideData: '',
      errors: []
    }
  },
  mounted () {
    this.loadDataForProgramGuideUpload()
  },

  methods: {
    ...mapActions([
      'uploadProgramGuide',
      'loadLibrariesForUser'
    ]),
    loadDataForProgramGuideUpload () {
      this.userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(this.userId)
    },
    uploadProgramGuideClicked () {
      let data = this.programGuideData
      if (!this.dataIsValid(data)) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: this.errors.join('\n')
        })
        this.errors = []
        return
      }
      let programGuide = JSON.parse(data)
      this.uploadProgramGuide({programGuideData: programGuide}).then(response => {
        if (response) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'ProgramGuide ' + response.cipCode + ' uploaded successfully.'
          })
          return this.$router.push({name: 'programGuideList'})
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Error in program guide format!'
          })
        }
      })
    },
    dataIsValid (programGuide) {
      let defaultError = 'Please ensure Program Guide "title" and "cipCode" fields are set.'
      if (!programGuide) {
        this.errors.push(defaultError)
        return false
      }
      try {
        let data = JSON.parse(programGuide)
        if (!data.cipCode || !data.title) {
          this.errors.push(defaultError)
          return false
        }
      } catch (err) {
        this.errors.push('Malformed JSON detected.')
        return false
      }
      return true
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'geoIdMap': state => state.career.geoIdMap
    })
  },
  watch: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideUpload.vue